import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type CreateDealerPricingRequestsPayload = {
  procurementFeeExGST: number;
  requestedExteriorColour: string;
  requestedInteriorColour: string;
  noteToDealer: string;
  selectedDealerIds: string[];
};

export const createQuoteDealerPricingRequests = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: CreateDealerPricingRequestsPayload
    ): Promise<string[]> => {
      return fetchWithAuth<string[]>("createDealerPricingRequests", quoteId, {
        requestOptions: {
          method: "post",
          body: JSON.stringify(payload),
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([["quoteDealerPricingRequests", quoteId]]),
  });
};
